<template>
  <div>
    <div class="mb-1">
      <label class="font-weight-bold">Режим замка прогона</label>
      <v-select
        v-if="modes && selectedMode"
        v-model="selectedMode"
        label="title"
        :clearable="false"
        :options="modes"
        @input="onModeChange"
      >
        <template
          slot="option"
          slot-scope="item"
        >
          {{ item.title }}
          <small class="text-muted"><i>({{ item.value }})</i></small>
        </template>
      </v-select>
    </div>
    <b-alert
      v-if="isTrigger && selectedMode && selectedMode.value === 'exclusive'"
      show
      variant="warning"
      class="p-1"
    >
      Эта сборка привязана как триггер записи. Монопольный режим замка выстроит в очередь все
      сохранения записей цели — для триггера обычно подходит «Свободный» или «По параметрам».
    </b-alert>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { BAlert } from 'bootstrap-vue'
import useCubus from '@/cubus/services/useCubus'
import useJwt from '@/cubus/jwt/useJwt'

/**
 * CUB-900 (ТЗ 1.7 §5.3): режим замка прогона в карточке сборки.
 *
 * `runlockmode` — обычный атрибут генерического объекта `object` (та же таблица `objects`, что и
 * name/descr), а не поле специализированной модели CubusObject (как allowindatamode, PROP-466, у
 * него тоже нет отражения в объектной модели бэка) — поэтому читается и пишется как ОБЫЧНАЯ
 * запись через record/saverecord с objectsid='object', тем же путём, что renameObject() в
 * конструкторе меняет name, а не через objectfull текущей сборки.
 *
 * BUG-671: ЧТЕНИЕ — одним служебным методом `mountlockinfo` (грант только на саму сборку), а не
 * запросами к `object`/`mountlockmode`/`objectparam` под правами пользователя: у ролей без
 * грантов на эти таблицы открытие настроек давало тосты «access denied».
 */
export default {
  name: 'CbsMountLockMode',
  components: {
    vSelect,
    BAlert,
  },
  props: {
    objectFull: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modes: null,
      selectedMode: null,
      isTrigger: false,
    }
  },
  created() {
    this.load()
  },
  methods: {
    // §5.3: «ПУСТО ЗНАЧИТ free» — бэк отдаёт уже с этим умолчанием (PostgresqlConnector.mountLockMode).
    load() {
      if (!this.objectFull || !this.objectFull.object) return
      useJwt.query({
        query: { method: 'mountlockinfo', mode: 'sync', param: { objectid: this.objectFull.object.id } },
      }).then(response => {
        const d = response.data && (response.data.result || response.data)
        if (!d || response.data.error) {
          if (response.data && response.data.error) useCubus.toastError(this, response.data.error)
          return
        }
        this.modes = d.modes || []
        this.isTrigger = !!d.istrigger
        this.selectedMode = this.modes.find(m => m.value === d.mode) || this.modes.find(m => m.value === 'free') || null
      })
    },
    onModeChange(mode) {
      if (!mode || !this.objectFull || !this.objectFull.object) return
      useCubus.saveRecord(this, {
        objectsid: 'object',
        record: {
          id: { value: this.objectFull.object.id, status: 'loaded' },
          runlockmode: { value: mode.value, status: 'changed' },
        },
      }).then(saved => {
        if (saved) useCubus.toastMessage(this, 'Режим замка сохранён.')
      })
    },
  },
}
</script>

<style scoped>

</style>
